import React from 'react';
import { Grid, Box, styled } from '@mui/material';
import BookingSummary from '../BookingInfo/BookingSummary';

const MainBox = styled(Box)(({ theme }) => ({
    m: 2,
    maxWidth: '800px',
    minWidth: '375px',
    [theme.breakpoints.only('sm')]: {
        minWidth: '610px',
    },
    [theme.breakpoints.only('md')]: {
        minWidth: '490px',
    },
    [theme.breakpoints.only('lg')]: {
        minWidth: '590px',
    },
    [theme.breakpoints.only('xl')]: {
        minWidth: '790px',
    },
}));

const HomeGrid = styled(Grid)(({ theme }) => ({
    justifyContent: 'center',
    alignItems: 'top',
    display: 'flex',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
        marginTop: '35px',
    },
}));

const BookingSummaryGrid = props => {
    return (
        <Grid
            container
            xs={12}
            directon="row"
            justifyContent="space-around"
            alignItems="top"
            className="hero"
            sx={props.sx}
        >
            {/* <Grid
                container
                directon="row"
                sx={{ width: '100%', marginTop: '50px' }}
                alignItems="top"
            > */}
            <HomeGrid item xs={12}>
                <MainBox sx={{ marginTop: '20px', width: '100%' }}>
                    <BookingSummary
                        title={props.Grid1.title}
                        subtitle={props.Grid1.subtitle}
                        type={props.Grid1.type}
                        booking={props.booking}
                        status={props.Grid1.status}
                        status2={props.Grid1.status2}
                        profileType={props.Grid1.profileType}
                        showStatus={props.Grid1.showStatus}
                        loading={props.loading}
                    />
                </MainBox>
            </HomeGrid>
            <HomeGrid item xs={12}>
                <MainBox sx={{ marginTop: '20px', width: '100%' }}>
                    <BookingSummary
                        title={props.Grid2.title}
                        subtitle={props.Grid2.subtitle}
                        type={props.Grid2.type}
                        booking={props.booking}
                        status={props.Grid2.status}
                        status2={props.Grid2.status2}
                        status3={props.Grid2.status3}
                        profileType={props.Grid2.profileType}
                        showStatus={props.Grid2.showStatus}
                        loading={props.loading}
                    />
                </MainBox>
            </HomeGrid>
            {/* </Grid> */}
        </Grid>
    );
};

export default BookingSummaryGrid;
